import { Currency } from '@/core/currency/interfaces';

const DOP: Currency = {
    name: 'Dominican Peso',
    demonym: 'Dominican',
    majorSingle: 'Peso',
    majorPlural: 'Pesos',
    codeNumeric: '214',
    symbol: 'RD$',
    symbolNative: '$',
    minorSingle: 'Centavo',
    minorPlural: 'Centavos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'DOP',
    delimiters: {
        thousands: ',',
        decimal: '.'
    }
};

export default DOP;
